module.exports = __webpack_public_path__ + "media/images/sales/early/icon-apply-03-453dbd0bf55747466a19cc0e13ae5084.svg";